import React from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import { LocalTimeInfo } from '../LocalTime/LocalTime';

export const ProUserInfoContainer = ({ timeZone, isOnline }: { timeZone: string; isOnline: boolean }) => {
    const isOnlineTitle = isOnline ? (
        <I18n k="seller_pages_toolbox.local_time_info.online" />
    ) : (
        <I18n k="seller_pages_toolbox.local_time_info.offline" />
    );
    return (
        <div className="flex co-text-dark m-b-4">
            {isOnlineTitle}
            {timeZone && (
                <>
                    &nbsp;•&nbsp; <LocalTimeInfo timeZone={timeZone} />
                </>
            )}
        </div>
    );
};
